import styled from '@emotion/styled';
import { Box, Button, Card, CardActionArea, CircularProgress, Divider, Typography } from '@mui/material'
import React from 'react'
import { VirtuosoGrid } from 'react-virtuoso'
import { MoshaveranDispatch } from './model';
import AutoSizer from 'react-virtualized-auto-sizer';
import '../../../../../../Util/ext'
import MoshaveranState from '../../State/MoshaveranState';

const ItemContainer = styled.div`
  padding: 0.5rem;
  width: 50%;
  display: flex;
  flex: none;
  align-content: stretch;
  box-sizing: border-box;

  @media (max-width: 1024px) {
    width: 50%;
  }

  @media (max-width: 300px) {
    width: 100%;
  }
`

const ItemWrapper = styled.div`
  flex: 1;
  text-align: center;
  font-size: 80%;
  padding: 1rem 1rem;
  border: 1px solid var(gray);
  white-space: nowrap;
`

const ListContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
`

class Moshaveran extends React.PureComponent<{}>{

    componentDidMount(): void {
        let dispatcher: MoshaveranDispatch = (this.props as any).dispatcher
        dispatcher.fetchMoshaveranList()
    }

    render() {

        let dispatcher: MoshaveranDispatch = (this.props as any).dispatcher
        let state: MoshaveranState = (this.props as any).state

        let html: JSX.Element

        if (state.loading && state.data.length === 0) {
            html = <Box sx={{ flexGrow: 1, flexDirection: 'column', mt: 5 }} display="flex"
                justifyContent="center"
                alignItems="center">
                <CircularProgress />
                <Typography variant="subtitle1" sx={{ mr: 1, ml: 1 }}>
                    در حال دریافت اطلاعات
                </Typography>
            </Box>
        } else if (state.data && state.data.length === 0) {
            html = <Box sx={{ flexGrow: 1, flexDirection: 'column', mt: 5 }} display="flex"
                justifyContent="center"
                alignItems="center">
                <Typography variant="subtitle1" sx={{ mr: 1, ml: 1 }} color='error'>
                    اطلاعات یافت نشد
                </Typography>
                <Button variant="contained" color='error' size='small' onClick={() => {
                    dispatcher.fetchMoshaveranList()
                }}>تلاش مجدد</Button>
            </Box>
        } else if (state.error) {
            html = <Box sx={{ flexGrow: 1, flexDirection: 'column', mt: 5 }} display="flex"
                justifyContent="center"
                alignItems="center">
                <Typography variant="subtitle1" sx={{ mr: 1, ml: 1 }} color='error'>
                    اطلاعات دریافت نشد
                </Typography>
                <Button variant="contained" color='error' size='small' onClick={() => {
                    dispatcher.fetchMoshaveranList()
                }}>تلاش مجدد</Button>
            </Box>
        } else {

            html = <Box sx={{ pr: 1, pl: 1, pt: 2, pb: 2 , width : '100%' , height : '300px'}}>
                <VirtuosoGrid className='none-scrollbar' components={{
                    Item: ItemContainer,
                    List: ListContainer as any,
                    ScrollSeekPlaceholder: ({ height, width, index }) => (
                        <ItemContainer>
                            <ItemWrapper>{'--'}</ItemWrapper>
                        </ItemContainer>
                    ),
                }} totalCount={state.data?.length} itemContent={(index, data, context) => {
                    let value = state.data[index]

                    return <Card key={index} variant="elevation" sx={{ width: '100%', borderRadius: '12px', borderColor: 'transparent' }} >

                        <Box sx={{ width: '100%', flexDirection: 'row' }} display='flex' >
                            <AutoSizer style={{ width: '33%' }}>
                                {({ width , height }: any) => {
                                    return (
                                        <Box
                                            component="img"
                                            sx={{
                                                height: height,
                                                width: width / 3,
                                                objectFit: 'cover'
                                            }}
                                            alt='vilage'
                                            src={value.pic}
                                            crossOrigin='anonymous'
                                        />
                                    )
                                }
                                }
                            </AutoSizer>

                            <Divider orientation="vertical" variant="middle" flexItem sx={{ ml: 0.1, mr: 0.1 }} />

                            <Box sx={{ width: '67%', flexDirection: 'column', mr: 0.5 }} display='flex'>

                                <Box sx={{ flexDirection: 'column', pr: 0.1, pl: 0.1 }} display='flex' justifyContent="center">
                                    <Typography variant="subtitle2" display="block" gutterBottom color='primary' textAlign='start'>
                                        {value.name}
                                    </Typography>
                                    <Typography variant="subtitle2" display="block" gutterBottom  color='primary' textAlign='start'>
                                        {value.phone}
                                    </Typography>
                                </Box>

                            </Box>
                        </Box>


                    </Card>

                }} />
            </Box>
        }

        return html
    }
}

export default Moshaveran